export interface InfoIcon {
  labelTitle: string;
  labelSrOnly?: boolean;
  srText: string;
  ariaRole?: string;
}
